import React from 'react';

import {
  Box,
  Flex,
  SectionLayout,
  StyleClosetTheme,
  ThemeColor,
  get as themeGet,
} from '@betterment/style-closet-react';
import styled from '@emotion/styled';

import CloseButton from './CloseButton';
import TakeoverHeader from './TakeoverHeader';

import { ModalContent, ModalOverlay } from '../../Checking/modal-helpers';
import GradientCheck from '../../images/gradient_check.png';

const sidebarBackground = (theme: StyleClosetTheme, backgroundColor?: ThemeColor) => {
  if (backgroundColor) {
    return theme.colors[backgroundColor];
  }
  return themeGet('colors.bmtTeal');
};

interface Props {
  title: string;
  sidebarColor?: SidebarProps['bg'];
  sidebarImageUrl?: string;
  closeHandler?: () => void;
}

interface SidebarProps {
  bg?: ThemeColor;
  imageUrl?: string;
}

const FlexFullViewportHeight = styled(Flex)`
  height: 100vh;
`;

const Sidebar = styled(Box)<SidebarProps, StyleClosetTheme>`
  background: url(${props => props.imageUrl || GradientCheck}), ${props => sidebarBackground(props.theme, props.bg)}};
  background-position: -70% 100px, 0;
  background-repeat: no-repeat, no-repeat;
  background-size: 75%, auto;
`;

const WorkflowSuccessLayout: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  title,
  sidebarImageUrl,
  sidebarColor,
  closeHandler,
}) => (
  <ModalOverlay>
    <ModalContent aria-label="success">
      {closeHandler && <CloseButton closeHandler={closeHandler} />}
      <FlexFullViewportHeight flexDirection={['column', 'column', 'row']}>
        <Sidebar width={[1, 1, 4 / 10]} pb={[9, 9, 0]} bg={sidebarColor} imageUrl={sidebarImageUrl}>
          <Box display={['block', 'block', 'none']} px="8">
            <TakeoverHeader title={title} />
          </Box>
        </Sidebar>
        <Box width={[1, 1, 6 / 10]} bg="white" pl={[0, 0, 9]} maxWidth="600px">
          <Box display={['none', 'none', 'block']}>
            <SectionLayout py="0">
              <SectionLayout.ContentWrapper>
                <TakeoverHeader title={title} />
              </SectionLayout.ContentWrapper>
            </SectionLayout>
          </Box>
          <SectionLayout py="9">
            <SectionLayout.ContentWrapper>{children}</SectionLayout.ContentWrapper>
          </SectionLayout>
        </Box>
      </FlexFullViewportHeight>
    </ModalContent>
  </ModalOverlay>
);

export default WorkflowSuccessLayout;
